<app-navigation></app-navigation>
<div class="content-sec">
  <div class="container">

    <notifier-container></notifier-container>

    <!--  RESET PASSWORD - STEP 01 SECTION  -->
    <div *ngIf="isStep1" class="card shadow-md-lg border-md-0 mb-3 mb-5">
      <div class="row no-gutters">
        <div class="col-md-6 d-none d-md-block d-lg-block">
          <div class="login-bg">
            <img src="./assets/images/login-bg.png" class="card-img" alt="login-background">
          </div>
        </div>
        <div class="col-md-6">
          <div class="card-body text-center p-3 ml-md-0 mr-md-0 ml-lg-5 mr-lg-5 mt-0 mt-md-3">
            <img class="logform-logo mb-3 mt-2" src="./assets/images/logo-v.svg" width="75" alt="payd-logo">
            <h1 class="card-title ml-md-0 mr-md-0 mt-3 mb-5">Forgot Password?</h1>

            <form class="ml-md-5 mr-md-5 mb-2" [formGroup]="forgetPwdForm">
              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-envelope"></i></span>
                  </div>
                  <input type="email" class="form-control" placeholder="Email" aria-label="Email" [(ngModel)]="email"
                         aria-describedby="basic-addon1" formControlName="email"
                         [ngClass]="{'is-invalid': forgetPwdForm.get('email').touched && forgetPwdForm.get('email').invalid}">
                  <div *ngIf="forgetPwdForm.get('email').touched && forgetPwdForm.get('email').invalid"  class="invalid-feedback text-right">
                    <div *ngIf="forgetPwdForm.get('email').errors.required">This field is required.</div>
                    <div *ngIf="forgetPwdForm.get('email').errors.pattern">Please enter a valid email address.</div>
                  </div>
                </div>
              </div>

              <button type="submit" class="btn btn-primary w-100 p-2 mt-1" [disabled]="!forgetPwdForm.valid" (click)=submitStep1($event.target)>SUBMIT</button>
            </form>
            <p class="card-text">
              <small class="text-muted">Back to</small>
              <small class="text-muted"><a routerLink="/login"><strong> Sign In </strong></a></small>
              <small class="text-muted">here</small>
            </p>
          </div>
        </div>
      </div>
    </div>


    <!--  RESET PASSWORD - STEP 02 SECTION  -->
    <div *ngIf="isStep2" class="card shadow-md-lg border-md-0 mb-3 ml-3 mr-3 mb-5">
      <div class="row no-gutters">
        <div class="col-md-6 d-none d-md-block d-lg-block">
          <div class="login-bg">
            <img src="./assets/images/login-bg.png" class="card-img" alt="login-background">
          </div>
        </div>
        <div class="col-md-6">
          <div class="card-body text-center p-3 ml-md-0 mr-md-0 ml-lg-5 mr-lg-5 mt-0 mt-md-3">
            <img class="logform-logo mb-3 mt-2" src="./assets/images/logo-v.svg" width="75" alt="payd-logo">
            <h1 class="card-title ml-md-0 mr-md-0 mt-3 mb-5">Reset Your Password</h1>

            <form class="mr-md-5 mb-2 mt-3" [formGroup]="resetForm">
              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon2"><i class="fas fa-unlock-alt"></i></span>
                  </div>
                  <input type="text" class="form-control" placeholder="OTP" aria-label="otp" [(ngModel)]="otp"
                         aria-describedby="basic-addon2" formControlName="otp"
                         [ngClass]="{'is-invalid': resetForm.get('otp').touched && resetForm.get('otp').invalid}">
                  <div *ngIf="resetForm.get('otp').touched && resetForm.get('otp').invalid"  class="invalid-feedback text-right">
                    <div *ngIf="resetForm.get('otp').errors.required">This field is required.</div>
                    <div *ngIf="resetForm.get('otp').errors.pattern">OTP must be 6 digits.</div>
                  </div>
                </div>
              </div>
<!--              <p class="card-text forget-pwd text-left ml-2"><a (click)="resendConfirmationCode()"><small class="text-muted">Re-send OTP</small></a></p>-->

              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon3"><i class="fas fa-lock"></i></span>
                  </div>
                  <input type="password" class="form-control" placeholder="New Password" aria-label="Password" [(ngModel)]="newPassword"
                         aria-describedby="basic-addon3" formControlName="newPassword"
                         [ngClass]="{'is-invalid': resetForm.get('newPassword').touched && resetForm.get('newPassword').invalid}">
                  <div *ngIf="resetForm.get('newPassword').touched && resetForm.get('newPassword').invalid" class="invalid-feedback text-right">
                    <div *ngIf="resetForm.get('newPassword').errors.required">This field is required.</div>
                    <div *ngIf="resetForm.get('newPassword').errors.pattern">Password must be minimum 8 characters, at least 1 uppercase, 1 lowercase, 1 number & 1 special character</div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon4"><i class="fas fa-lock"></i></span>
                  </div>
                  <input type="password" class="form-control" placeholder="Confirm Password" aria-label="ConfirmPassword" [(ngModel)]="confirmNewPassword"
                         aria-describedby="basic-addon4" formControlName="confirmPassword"
                         [ngClass]="{'is-invalid': resetForm.get('confirmPassword').touched && resetForm.get('confirmPassword').invalid}">
                  <div *ngIf="resetForm.get('confirmPassword').touched && resetForm.get('confirmPassword').invalid" class="invalid-feedback text-right">
                    <div *ngIf="resetForm.get('confirmPassword').errors.required">This field is required.</div>
                    <div *ngIf="resetForm.get('confirmPassword').errors.passwordValidity">Confirm Password does not match.</div>
                  </div>
                </div>
              </div>

               <p *ngIf="showResendOtp == true"  class="card-text forget-pwd text-right ml-2"><a routerLink="#" (click)="reSendOtp()"><small class="text-muted">Resend OTP</small></a></p>
              <button type="submit" class="btn btn-primary w-100 p-2 mt-1 mb-3" [disabled]="!resetForm.valid" (click)=submitStep2($event.target)>RESET PASSWORD</button>
              <p class="card-text"><small><a routerLink="#" (click)="resetBack($event.target)"><strong><i class="fas fa-angle-double-left"></i> BACK</strong></a></small></p>
            </form>
          </div>
        </div>
      </div>
    </div>


    <!--  RESET PASSWORD - STEP 03 (SUCCESS) SECTION  -->
    <div *ngIf="isStep3" class="card shadow-md-lg border-md-0 mb-3 ml-3 mr-3 mb-5">
      <div class="row no-gutters acc-success-gutter">
        <div class="col-md-6 d-none d-md-block d-lg-block">
          <div class="login-bg">
            <img src="./assets/images/login-bg.png" class="card-img" alt="login-background">
          </div>
        </div>
        <div class="col-md-6">
          <div class="card-body text-center p-3 ml-md-0 mr-md-0 ml-lg-5 mr-lg-5 mt-0 mt-md-3">
            <img class="logform-logo mb-3 mt-2" src="./assets/images/logo-v.svg" width="75" alt="payd-logo">
            <h1 class="card-title ml-md-0 mr-md-0 mt-3 mb-5">Success!</h1>

            <form class="ml-md-5 mr-md-5 mb-2">
              <div class="badge-msg row mr-sm-3 ml-sm-3 d-flex mb-md-3">
                <span class="badge badge-pill badge-success ml-1"><i class="fas fa-check fa-2x"></i></span>
                <p class="card-text text-left">Your password has been changed.</p>
              </div>

              <button type="submit" class="btn btn-primary w-100 p-2 mt-1" routerLink="/login">SIGN IN</button>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
